var _rect, _rect2, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemperature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 16,
    fill: "#FFF3ED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4302,
    y: 4.66187,
    width: 12.3684,
    height: 32.135,
    rx: 5.71289,
    fill: "#FFE5DA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5873,
    cy: 35.3831,
    r: 8.21228,
    fill: "#FFE5DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5742 35.4486C27.5936 33.556 26.2518 31.9544 24.4542 31.5795V9.43358C24.4542 8.97297 24.0718 8.59058 23.6112 8.59058C23.1506 8.59058 22.7682 8.97297 22.7682 9.43358V31.5832C20.9906 31.9732 19.6482 33.5543 19.6482 35.4466C19.6482 37.6427 21.4151 39.4096 23.6112 39.4096C25.8066 39.4096 27.5731 37.6438 27.5742 35.4486Z",
    fill: "#C78477",
    stroke: "#C78477",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6304 38.7225C25.4613 38.7225 26.9454 37.2384 26.9454 35.4075C26.9454 33.5767 25.4613 32.0925 23.6304 32.0925C21.7996 32.0925 20.3154 33.5767 20.3154 35.4075C20.3154 37.2384 21.7996 38.7225 23.6304 38.7225Z",
    fill: "#C31918"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.251 9.86255H21.001V10.3125H26.251V9.86255Z",
    fill: "#C78477"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.251 14.874H21.001V15.324H26.251V14.874Z",
    fill: "#C78477"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.251 19.8855H21.001V20.3355H26.251V19.8855Z",
    fill: "#C78477"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.251 24.9165H21.001V25.3665H26.251V24.9165Z",
    fill: "#C78477"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.251 29.9281H21.001V30.3781H26.251V29.9281Z",
    fill: "#C78477"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.251 12.3781H21.001V12.6781H26.251V12.3781Z",
    fill: "#C78477"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.251 17.3895H21.001V17.6895H26.251V17.3895Z",
    fill: "#C78477"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.251 22.401H21.001V22.701H26.251V22.401Z",
    fill: "#C78477"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.251 27.3931H21.001V27.6931H26.251V27.3931Z",
    fill: "#C78477"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.601 10.389C23.851 10.389 24.001 10.4475 24.001 10.5255V32.619C24.001 32.697 23.851 32.7555 23.651 32.7555H23.601C23.401 32.7555 23.251 32.697 23.251 32.619V10.5255C23.251 10.4475 23.401 10.389 23.601 10.389Z",
    fill: "#C31918"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/temperature.710de0483af7bcbf8ff8a45ebacaa094.svg";
export { ForwardRef as ReactComponent };